import React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Copyright from "../Components/Copyright";

const Login = () => {
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* <Avatar
          sx={{ m: 1, bgcolor: "secondary.main" }}
          src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
        /> */}
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/logo_no_bg.png`}
          alt="logo"
          className="w-100 mb-5"
        />

        <Typography component="h1" variant="h5" color="blue">
          ระบบฝึกงานและสหกิจศึกษา
        </Typography>

        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form
          action="./ldaptest.php"
          method="post"
          style={{ width: "100%", marginTop: "20px" }}
        >
          <input
            type="text"
            name="name"
            className="form-control"
            placeholder="username"
          />
          <br />
          <input
            type="password"
            name="pass"
            className="form-control"
            placeholder="password"
          />
          <br />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Sign In
          </Button>
        </form>
      </Box>
      <Copyright
        textColor="text.secondary"
        variant="body1"
        align="center"
        isShowOwner
      />
    </Container>
  );
};

export default Login;
